import { AxiosError } from 'axios';
import { restApi } from 'src/utilities/restApi';
import { ErrorResponse, SuccessResponse } from 'src/utilities/restApi/common/types/responses';
import { ResponseResetStatus } from 'src/utilities/restApi/kanri/types/resetStatus';
import { getCommonHeaders } from 'src/utilities/restApi/utilities/getCommonHeader';

const url = '/reset-status';

export const resetStatus = async () => {
  const headers = { headers: await getCommonHeaders() };
  const config = { ...headers };

  return new Promise<SuccessResponse<ResponseResetStatus>>((resolve, reject) => {
    restApi()
      .get<SuccessResponse<ResponseResetStatus>>(url, config)
      .then((response) => {
        resolve(response.data!);
      })
      .catch((error: AxiosError<ErrorResponse>) => {
        reject(error.response?.data);
      });
  });
};
